<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="输入订单号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initOfflineProjects"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initOfflineProjects" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initOfflineProjects" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <!-- <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        下订单
                    </el-button>
                </div>
            </div>

            <!-- 高级搜索条件  -->
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="4">
                            项目名称:
                            <el-input v-model="searchValue.keyword" placeholder="项目名称" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                                年度：<el-date-picker
                                                v-model="searchValue.year"
                                                type="year"
                                                size="mini"
                                                style="width: 125px;"
                                                format="yyyy"
                                                value-format="yyyy"
                                                placeholder="活动时间">
                                        </el-date-picker>
                        </el-col>
                        <el-cal :span="4">
                                项目时间：<el-date-picker
                                                            v-model="searchValue.timeRange"
                                                            type="daterange"
                                                            size="mini"
                                                            style="width: 225px;"
                                                            range-separator="至"
                                                            value-format="yyyy-MM-dd"
                                                            start-placeholder="开始时间"
                                                            end-placeholder="结束时间">
                                                    </el-date-picker>
                        </el-cal>
                    </el-row>
                    <el-row style="margin-top: 10px" type="flex" justify="end">
                        
   
                        <el-col :span="5" :offset="5">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initOfflineProjects('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="projects"
                    border
                    :row-class-name="tableAddClass"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%;"
                    :row-key="row=>row.pCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="orderCode"
                        fixed
                        align="center"
                        label="订单号"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="requireDesc"
                        align="center"
                        label="需求规格描述"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="num"
                        align="center"
                        label="数量"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="address"
                        align="center"
                        label="收获地址"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="expressId"
                        align="center"
                        label="快递单号"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="imgUrl"
                        align="center"
                        label="制作图"
                        width="300">
                        <template slot-scope="scope" >
                           <el-popover
                                placement="top-start"
                                trigger="hover"
                                >
                                <el-image
                                style="max-width: 300px;max-height: 500px;"
                                    :src="scope.row.originUrl"
                                    :preview-src-list="scope.row.srcList"
                                />
                                <span style="color: #409eff;" slot="reference">{{scope.row.imgUrl}}</span>
                            </el-popover>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        align="center"
                        label="订单状态"
                        width="80">
                        <template slot-scope="scope">
                             {{getChangeType(scope.row.status,'orderStatus')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="makeTime"
                        align="center"
                        label="下单时间"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="sureTime"
                        align="center"
                        label="确认时间"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="sendTime"
                        align="center"
                        label="发货时间"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="receiveTime"
                        align="center"
                        label="收货时间"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="orderPName"
                        align="center"
                        label="下单人"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="cTime"
                        align="center"
                        label="创建时间"
                        width="180">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="200"
                        label="操作">
                    <template slot-scope="scope">
                        <!-- <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" type="warning" v-has>锁定</el-button> -->
                        <el-button @click="sureOrder(scope.row)" style="padding: 3px" type="primary"  v-if="scope.row.status == '0'&&user.username=='admin'" size="mini">确认</el-button>
                        <el-button @click="showProjectDetail(scope.row)" style="padding: 3px" type="primary" v-if="scope.row.status == '1'&&user.username=='admin'" size="mini">发货</el-button>
                        <el-button @click="receiveOrder(scope.row)" style="padding: 3px" type="primary" v-if="scope.row.status == '2'&&user.username!='admin'" size="mini">收货</el-button>
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" v-if="scope.row.status == '0'"  size="mini" type="danger">删除
                        </el-button>  
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                 :title="请添加快递单号"
                label-width="80px"
                :visible.sync="showDetail"  
                width="40%"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                 >
                <el-form :model="project" label-position="right" label-width="120px" :rules="rules" ref="empForm1">
                            <el-form-item label="快递单号:" prop="expressId">
                                <el-input size="mini" style="width: 200px" prefix-icon="el-icon-edit" v-model="project.expressId"
                                          placeholder="请输入快递单号"></el-input>
                            </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelDetailEdit">取 消</el-button>
                    <el-button type="primary" @click="doAddDetail">确 定</el-button>
                </span>
            </el-dialog>




        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <!-- <el-dialog :title="addFileTitleName" :modal-append-to-body="false"
                :close-on-click-modal="false" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
            </div>
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog> -->

        <!-- 修改和添加模块 -->
        <el-dialog
                :title="title"
                label-width="80px"
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                width="30%">
            <div>
                <el-form :model="project"  label-width="120px" :rules="rules" ref="empForm">
                    <el-form-item label="需求描述:" prop="requireDesc">
                        <el-input type="textarea" size="mini" style="width: 300px" prefix-icon="el-icon-edit" v-model="project.requireDesc"
                        placeholder="需求描述"></el-input>
                    </el-form-item>
                    <el-form-item label="数量:" prop="num">
                        <el-input size="mini" style="width: 300px" prefix-icon="el-icon-edit"  v-model="project.num"
                                    placeholder="请输入数量"></el-input>
                    </el-form-item>
                    <el-form-item label="地址、电话:" prop="address">
                        <el-input type="textarea" size="mini" style="width: 300px" prefix-icon="el-icon-edit"  v-model="project.address"
                                    placeholder="请输入地址、电话"></el-input>
                    </el-form-item>
                    <el-form-item label="制作图:" prop="imgUrl">
                            <el-upload 
                                :show-file-list="true"
                                :before-upload="beforeUpload"
                                :on-success="onSuccess"
                                :on-error="onError"
                                :file-list="fileList"
                                :on-remove="onRemove"
                                :disabled="importDataDisabled"
                                accept=".jpg,.jpeg..png"
                                style="display: inline-flex;margin-right: 8px"
                                action="/yl/order/img/upload">
                                <el-button  :disabled="fileList.length==0?false:true" type="success" :icon="importDataBtnIcon">
                                上传文件
                                </el-button>
                        </el-upload>
                    </el-form-item>
                    
                        <!-- <el-col :span="7">
                            <el-form-item label="项目来源:" prop="source">
                                <el-select v-model="project.source" clearable="" placeholder="项目来源" size="mini">
                                    <el-option
                                            v-for="item in sourceList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                      
                    
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doAddEmp">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "projectInfo",
        data() {
            return {
               
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null,
                    year:new Date()
                },
                user:'',
                invoiceStatusList:[{
                    dictValue: '0',
                    dictLabel: '未开票'
                    }, {
                    dictValue: '1',
                    dictLabel: '已开票'
                    }, {
                    dictValue: '2',
                    dictLabel: '部分开票'
                }],
                arrivalSituationList:[{
                    dictValue: '0',
                    dictLabel: '未到账'
                    }, {
                    dictValue: '1',
                    dictLabel: '已到账'
                    }, {
                    dictValue: '2',
                    dictLabel: '部分到账'
                }],
                detailTitle:'',
                showChangeDetail : false,
                showDetail : false,
                restaurants : [],
                restaurantsSpecs : [],
                places: [],
                user:"",
                title: '',
                pCode:'',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                projects: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                imgName:'',
                page: 1,
                keyword: '',
                size: 10,
                fileList:[],
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'],
                options: [ ],
                inputDepName: '所属部门',
                project: {
                
                },
                details:[],
                detail:{
                    count:1,
                    type:0,
                    gov:'0',
                    budgutPrice:'',
                    pCode:'',
                    unit:'',
                    price:'',
                    costPrice:''
                },
                materials:[],
                materialNameTemp:'',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    detailName: [{required: true, message: '请输入明细名', trigger: 'change'}],
                    price: [{required: true, message: '请输入单价', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)|(^[0-9]\.[0-9]([0-9])([0-9])?$)/, message: '请输入正确的格式,可保留三位小数' }],
                    count: [{required: true, message: '请输入数量', trigger: 'blur'},{ pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])([0-9])?$)/, message: '请输入正确的格式,可保留三位小数' }],
                    address: [{required: false, message: '请输入员工地址', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initOfflineProjects();
            this.initData();
        },
        methods: {
            staticPrice(){
                if(this.materials.length == 0){
                    this.getBudgutPrice();
                    return
                }
                let tempMaterials = '';
                let minNum = this.materials[0];
                let maxNum = this.materials[0];
                for(let index in this.materials){
                    if(minNum.countMin>this.materials[index].countMin){
                        minNum = this.materials[index]
                    }
                    if(maxNum.countMax<this.materials[index].countMax){
                        maxNum = this.materials[index]
                    }
                    if(this.materials[index].countMin <= this.detail.count&&this.materials[index].countMax > this.detail.count){
                        tempMaterials = this.materials[index]
                    }
                }
                if(tempMaterials == ''){
                    if(minNum.countMin>=this.detail.count){
                        this.detail.count = minNum.countMin
                        tempMaterials =minNum
                    }else if(maxNum.countMax<=this.detail.count){
                       tempMaterials = maxNum
                    }
                }
                if(this.detail.price>0&&this.detail.price !=tempMaterials.price){

                }else  if(this.detail.gov&&this.detail.gov == '0'){
                    this.detail.price = tempMaterials.price;
                }else{
                    this.detail.price = tempMaterials.priceGov;
                }
                this.getBudgutPrice();
            },
            changeGov(){
                this.staticPrice();
            },
            getBudgutPrice(){
                if(this.detail.price&&this.detail.count){
                    this.detail.budgutPrice =  this.NumberMul(this.detail.price , this.detail.count);
                }else{
                    this.detail.budgutPrice =  '';
                }
            },
            handleSelectSpecs(item){
                console.log(item.value);
                if(item.value == "无"){
                    item.value = undefined;
                }
                this.postRequest("/yl/offline/materials", {materialName:this.materialNameTemp,materialSpecs:item.value}).then(resp => {
                                if (resp) {
                                    this.materials = resp.data;
                                    if(this.materials.length >= 1){
                                        this.detail.unit = this.materials[0].unit
                                        this.detail.price = this.materials[0].price
                                    }
                                    this.staticPrice();
                                }
                            })
               
            },
            handleSelect(item){
                this.materialNameTemp = item.value;
                this.postRequest("/yl/offline/material/specs", {materialName:item.value}).then(resp => {
                                if (resp) {
                                    this.restaurantsSpecs = resp.data;
                                    if(resp.data.length == 1 && !resp.data[0].value){
                                        this.restaurantsSpecs = [{value:'无'}]
                                    }
                                }
                            })
                this.rules.detailSpecs = [{required: true, message: '请选择明细名', trigger: 'blur'}];
            },
            querySearchPlace(queryString, cb) {
                var restaurants = this.places;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearchSpecs(queryString, cb) {
                var restaurants = this.restaurantsSpecs;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            putDetail(row){
                this.detailTitle = '编辑明细';
                this.detail = row;
                this.materialNameTemp = row.detailName;
                this.handleSelectSpecs({value:row.detailSpecs});
                this.showChangeDetail = true;
                // this.postRequest("/yl/offline/material/names", {}).then(resp => {
                //                 if (resp) {
                //                     this.restaurants = resp.data;
                //                 }
                //             })
            },
            addDetail(){
                this.detailTitle = '添加明细';
                this.showChangeDetail = true;
                this.postRequest("/yl/offline/material/names", {}).then(resp => {
                                if (resp) {
                                    this.restaurants = resp.data;
                                }
                            })
            },
            cancelDetailEdit(){
                this.showDetail = false;
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            tableAddClass({row,rowIndex}) {
                if (row.pStatus == '0') {
                    return 'tr-gray';
                }else if(row.pStatus == '1'){
                    return 'tr-blue';
                }else if(row.pStatus == '2'){
                    return 'tr-green';
                }else if(row.pStatus == '3'){
                    return 'tr-yellow';
                }else {
                    return '';
                }
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('arrivalSituation' == z){
                    for (var i = 0; i < this.arrivalSituationList.length; i++) {
                        if (this.arrivalSituationList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.arrivalSituationList[i].dictLabel;
                        }
                    }
                }else if('pStatus' == z){
                    for (var i = 0; i < this.pStatusList.length; i++) {
                        if (this.pStatusList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.pStatusList[i].dictLabel;
                        }
                    }
                }else if('invoiceStatus' == z){
                    for (var i = 0; i < this.invoiceStatusList.length; i++) {
                        if (this.invoiceStatusList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.invoiceStatusList[i].dictLabel;
                        }
                    }
                }else if('orderStatus' == z){
                        if ('0' == e) { //dictValue，dictLabel保持和上面定义一致
                            return '待接单';
                        }else if('1' == e){
                            return '已接单';
                        }else if('2' == e){
                            return '已发货';
                        }else if('3' == e){
                            return '已完成';
                        }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataDisabled = false;
                this.importDataBtnIcon = 'el-icon-upload2';
                this.fileList = fileList
                this.imgName = response.obj
            },
            onRemove(file, fileList){
                this.fileList = fileList
            },
            beforeUpload(file) {
                this.importDataBtnText = '正在上传';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportDill() {
                this.putRequest("/yl/offline/project/expHead", this.project).then(resp => {
                                if (resp) {
                                    window.open('/yl/offline/export/' + this.pCode, '_parent');
                                }
                            })
                
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.project = {
                    "id":"",
                    "pCode":"",
                    "pName":"",
                    "place":"",
                    "dockingPerson":"",
                    "pTime":"",
                    "pStartTime":"",
                    "pEndTime":"",
                    "budgutPrice":"",
                    "invoicePrice":"",
                    "padedMoney":"",
                    "invoiceRemark":"",
                    "budgutCost":"",
                    "reimbuseCost":"",
                    "arrivalSituation":"",
                    "arrivalTime":"",
                    "remark":"",
                    "profitRate":"",
                    "lockStatue":"",
                    "invoiceStatus":"",
                    "pStatus":"",
                    "cTime":"",
                    "gTime":""
                }
                this.inputDepName = '';
            },
            sureOrder(data){
                this.putRequest("/yl/order/img/sure", data).then(resp => {
                                if (resp) {
                                    this.initOfflineProjects();
                                }
                            })
            },

            receiveOrder(data){
                this.putRequest("/yl/order/img/receive", data).then(resp => {
                                if (resp) {
                                    this.initOfflineProjects();
                                }
                            })
            },
            showProjectDetail(data){
                 this.showDetail = true;
                 this.pCode = data.orderCode;
            },
            initDetails(){
                this.getRequest("/yl/offline/details/"+this.pCode).then(resp => {
                    if (resp) {
                        this.details = resp.data;
                    }
                })
            },
            
            deleteDetail(data){
                this.$confirm('此操作将永久删除【' + data.detailName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/offline/detail/" + data.detailCode).then(resp => {
                        if (resp) {
                            this.initDetails();
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.orderCode + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/employee/basic/" + data.id).then(resp => {
                        if (resp) {
                            this.initOfflineProjects();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddDetail() {
                this.project.orderCode = this.pCode
                this.$refs['empForm1'].validate(valid => {
                    if (valid) {
                        this.putRequest("/yl/order/img/send", this.project).then(resp => {
                            if (resp) {
                                this.showDetail = false;
                                this.initOfflineProjects();
                            }
                        })
                    }
                });
            },
            emptyDetail(){
                this.detail={
                    count:1,
                    detailName:'',
                    type:0,
                    gov:'0',
                    budgutPrice:'',
                    pCode:this.pCode,
                    unit:'',
                    price:'',
                    costPrice:''
                }
            },
            doAddEmp() {
                if (this.project.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/offline/project", this.project).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.project.orderPName = this.user.name
                            this.project.orderPCode = this.user.username
                            this.project.imgUrl = this.imgName
                            this.postRequest("/yl/order/img/order", this.project).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initOfflineProjects();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.project.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            addToSrcList(data){
                data.srcList = [];
                data.srcList.push(data.originUrl);
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
                this.user = JSON.parse(window.sessionStorage.getItem("user"));
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initOfflineProjects();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initOfflineProjects('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加订单';
                this.dialogVisible = true;
            },
            initOfflineProjects(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['projectNameLike']=this.keyword
                this.searchValue['pageNo']=this.page
                this.searchValue['pageSize']=this.size
                this.searchValue['orderByClause']=' c_time desc '
                this.postRequest('/yl/order/img/orders', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.projects = resp.data;
                        for(let index in  this.projects){
                                let temp = this.projects[index];
                                temp.pNameNew = temp.pTime+" " + temp.pName;
                                this.projects[index].originUrl =  '/yl/order/img/'+this.projects[index].imgUrl
                                this.addToSrcList(this.projects[index]);
                        }
                        if(this.project.id){
                            for(let index in  this.projects){
                                let temp = this.projects[index];
                                temp.pNameNew = temp.pTime+" " + temp.pName;
                                if(this.project.pCode ==  this.projects[index].pCode){
                                    this.project = this.projects[index]
                                }
                            }
                        }
                        this.total = resp.total;
                    }
                });

                this.getRequest('/yl/offline/project/places').then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.places = resp.obj;
                    }
                });

                
            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
    .tr-gray{
        background-color: #c0c4cc !important;
    }
    .tr-blue{
        background-color: #B2E0FF !important;
    }
    .tr-green{
        background-color: #9EEA6A !important;
    }
    .tr-yellow{
        background-color: #FED55F !important;
    }
    .el-radio{
        margin-top: 8px !important;
    }
    .el-autocomplete-suggestion{
        width: auto!important;
    }
    .el-table__fixed-right {
        height: 100% !important;
    }
    .el-table__fixed{
        height: 100% !important;
    }

</style>
